/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Locale_DefaultInputs */

const he_profile_locale_default = /** @type {(inputs: Profile_Locale_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עברית (ברירת מחדל)`)
};

const en_profile_locale_default = /** @type {(inputs: Profile_Locale_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hebrew (default)`)
};

/**
* | output |
* | --- |
* | "Hebrew (default)" |
*
* @param {Profile_Locale_DefaultInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_locale_default = /** @type {((inputs?: Profile_Locale_DefaultInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Locale_DefaultInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_locale_default(inputs)
	return en_profile_locale_default(inputs)
});